import TypeIt from 'typeit'
import { random } from 'gsap/gsap-core'

export class PageHeader {

  isCallable() {
    return window.innerWidth > 1023
  }
  init() {
    const elements = document.querySelectorAll('.e__2--animate')

    elements.forEach( (element) => {

      const typingEffect = new TypeIt(element, {
        waitUntilVisible: true,
        speed: 60,
        cursor: false,
        afterComplete: function (instance) {
          instance.destroy();
        }
      })

      typingEffect
        .pause(1000)
        .type(".....................OK")
        .options({speed: random(50, 100)})
        .go()

    })
  }
}
